export default function GoogleReviews() {
  return (
    <section id="standort" className="py-16 sm:py-24 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-12">
          <span className="inline-block bg-[#F4B942]/20 text-[#1A2B4A] text-sm font-semibold px-4 py-2 rounded-full mb-4 uppercase tracking-widest">
            Unser Standort
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4A] mb-4">
            Wir sind in Wien für Sie da
          </h2>
          <p className="text-gray-500 text-base sm:text-lg max-w-xl mx-auto">
            Besuchen Sie uns persönlich oder kontaktieren Sie uns telefonisch – wir freuen uns auf Sie.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 items-stretch">
          <div className="md:col-span-2 w-full h-full min-h-[280px] sm:min-h-[380px] rounded-2xl overflow-hidden shadow-xl flex">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2659.234567!2d16.3089!3d48.2167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x476d079e5136d36f%3A0x6285956baa3f8b16!2sMaroltingergasse%2092%2C%201160%20Wien%2C%20Austria!5e0!3m2!1sde!2sat!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, display: 'block', flex: 1 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Elektro Tomasevic KG Standort"
            ></iframe>
          </div>

          <div className="flex flex-col gap-4 sm:gap-6">
            <div className="bg-white rounded-2xl p-5 sm:p-6 shadow-md">
              <div className="w-10 h-10 flex items-center justify-center bg-[#F4B942]/20 rounded-xl mb-3 sm:mb-4">
                <i className="ri-map-pin-2-fill text-[#F4B942] text-xl"></i>
              </div>
              <h4 className="font-bold text-[#1A2B4A] text-base sm:text-lg mb-1">Adresse</h4>
              <p className="text-gray-600 text-sm leading-relaxed">
                Maroltingergasse 92/1/5<br />
                1160 Wien, Österreich
              </p>
            </div>

            <div className="bg-white rounded-2xl p-5 sm:p-6 shadow-md">
              <div className="w-10 h-10 flex items-center justify-center bg-[#F4B942]/20 rounded-xl mb-3 sm:mb-4">
                <i className="ri-phone-fill text-[#F4B942] text-xl"></i>
              </div>
              <h4 className="font-bold text-[#1A2B4A] text-base sm:text-lg mb-1">Telefon</h4>
              <a href="tel:+436991223301" className="text-gray-600 text-sm hover:text-[#F4B942] transition-colors">
                +43 699 122 333 01
              </a>
            </div>

            <div className="bg-white rounded-2xl p-5 sm:p-6 shadow-md">
              <div className="w-10 h-10 flex items-center justify-center bg-[#F4B942]/20 rounded-xl mb-3 sm:mb-4">
                <i className="ri-mail-fill text-[#F4B942] text-xl"></i>
              </div>
              <h4 className="font-bold text-[#1A2B4A] text-base sm:text-lg mb-1">E-Mail</h4>
              <a
                href="mailto:elektro.tomasevic@gmail.com"
                className="text-gray-600 text-sm hover:text-[#F4B942] transition-colors break-all"
              >
                elektro.tomasevic@gmail.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
